import { render } from "./UserExpensesSection.vue?vue&type=template&id=194d3853&scoped=true&ts=true&lang=pug"
import script from "./UserExpensesSection.vue?vue&type=script&lang=ts"
export * from "./UserExpensesSection.vue?vue&type=script&lang=ts"

import "./UserExpensesSection.vue?vue&type=style&index=0&id=194d3853&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194d3853"]])

export default __exports__